import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import './TeamMember.css';

const TeamMember = (member) => {
  const { t } = useI18n();
  return (
    <div className="team-member">
      <a href={member.profileUrl} target="_blank" rel="noopener noreferrer">
        <img src={member.imageUrl} alt={member.name} className="member-image" />
      </a>
      <div className="member-text">
        <h3>{member.name}</h3>
        {member.websiteUrl && (
          <div className="member-profile-links">
            <p>{t('profile.role')}</p>
            <p>{t('profile.intro')}</p>
            <a href={member.websiteUrl} target="_blank" rel="noopener noreferrer">{t('profile.visitWebsite')} ↗</a>
            <Link to={member.profilePath}>{t('profile.readStory')} →</Link>
          </div>
        )}
        {member.websiteUrl ? (
          <>
            <p>{t('profile.yoyo.body')}</p>
            <ul>
              <li>{t('profile.yoyo.regional')}</li>
              <li>{t('profile.yoyo.national')}</li>
            </ul>
          </>
        ) : <div dangerouslySetInnerHTML={{ __html: member.description }}></div>}
      </div>
    </div>
  );
};

export default TeamMember;
